export default __webpack_public_path__ + "static/media/hm-pop-img.3ede7eb0.webp";